export interface RouteConfig {
  name: string;
  path: string;
}

export interface SigninRouteConfig extends RouteConfig {
  SetIdAndPw: RouteConfig;
}

export interface SubscriptionServiceRouteConfig extends RouteConfig {
  Create: RouteConfig;
  Detail: RouteConfig;
  Edit: RouteConfig;
}

export interface SubscriptionRouteConfig extends RouteConfig {
  Products: RouteConfig;
  Promotions: RouteConfig;
  PaymentHistory: RouteConfig;
  Chatbot: SubscriptionServiceRouteConfig;
  Voicebot: SubscriptionServiceRouteConfig;
  Centerflow: SubscriptionServiceRouteConfig;
}

export interface CallbotUsageFeeRouteConfig extends RouteConfig {
  Months: RouteConfig;
  Profiles: RouteConfig;
  Ops: RouteConfig;
  UsageStatement: RouteConfig;
}

export interface IntegrationRouteConfig extends RouteConfig {
  ChannelManagement: RouteConfig;
}

export interface TwoFactorAuthRouteConfig extends RouteConfig {
  Settings: RouteConfig;
  Verify: RouteConfig;
}

export interface SecurityRouteConfig extends RouteConfig {
  ChangePassword: RouteConfig;
  MyAccount: RouteConfig;
}

export interface RouterEnumType {
  Signin: SigninRouteConfig;
  Dashboard: RouteConfig;
  CustomerManagement: RouteConfig;
  CustomerDetail: RouteConfig;
  Subscription: SubscriptionRouteConfig;
  CallbotUsageFee: CallbotUsageFeeRouteConfig;
  Integration: IntegrationRouteConfig;
  Security: SecurityRouteConfig;
  TwoFactorAuth: TwoFactorAuthRouteConfig;
  SupportEnter: RouteConfig;
  SupportEnded: RouteConfig;
  Staff: RouteConfig;
}

export const RouterEnum: RouterEnumType = {
  // 지원 접속(운영자가 리셀러 회사에, 10-29) — 로그인 검사 밖
  SupportEnter: { name: 'SupportEnter', path: '/support/enter' },
  SupportEnded: { name: 'SupportEnded', path: '/support/ended' },
  Signin: {
    name: 'Signin',
    path: '/signin',
    SetIdAndPw: {
      name: 'signin-set-id-and-pw',
      path: '/set-id-and-pw',
    },
  },

  Dashboard: {
    name: 'Dashboard',
    path: '/dashboard',
  },

  // 고객관리 (리셀러의 고객 = 병원/제조사)
  CustomerManagement: {
    name: 'CustomerManagement',
    path: '/customers',
  },

  // 직원 계정(리셀러 서브 계정·접근 권한, 11-02)
  Staff: {
    name: 'StaffManagement',
    path: '/staff',
  },

  // 고객상세
  CustomerDetail: {
    name: 'CustomerDetail',
    path: '/customers/:id',
  },

  // 구독 관리
  Subscription: {
    name: 'Subscription',
    path: '/subscriptions',
    Products: {
      name: 'SubscriptionProducts',
      path: '/subscriptions/products',
    },
    Promotions: {
      name: 'SubscriptionPromotions',
      path: '/subscriptions/promotions',
    },
    PaymentHistory: {
      name: 'PaymentHistory',
      path: '/subscriptions/payment-history',
    },
    Chatbot: {
      name: 'SubscriptionChatbot',
      path: '/subscriptions/chatbot',
      Create: {
        name: 'SubscriptionChatbotCreate',
        path: '/subscriptions/chatbot/create',
      },
      Detail: {
        name: 'SubscriptionChatbotDetail',
        path: '/subscriptions/chatbot/:id',
      },
      Edit: {
        name: 'SubscriptionChatbotEdit',
        path: '/subscriptions/chatbot/:id/edit',
      },
    },
    Voicebot: {
      name: 'SubscriptionVoicebot',
      path: '/subscriptions/voicebot',
      Create: {
        name: 'SubscriptionVoicebotCreate',
        path: '/subscriptions/voicebot/create',
      },
      Detail: {
        name: 'SubscriptionVoicebotDetail',
        path: '/subscriptions/voicebot/:id',
      },
      Edit: {
        name: 'SubscriptionVoicebotEdit',
        path: '/subscriptions/voicebot/:id/edit',
      },
    },
    Centerflow: {
      name: 'SubscriptionCenterflow',
      path: '/subscriptions/centerflow',
      Create: {
        name: 'SubscriptionCenterflowCreate',
        path: '/subscriptions/centerflow/create',
      },
      Detail: {
        name: 'SubscriptionCenterflowDetail',
        path: '/subscriptions/centerflow/:id',
      },
      Edit: {
        name: 'SubscriptionCenterflowEdit',
        path: '/subscriptions/centerflow/:id/edit',
      },
    },
  },

  // Callbot usage fee ('콜봇 사용료'): a parent with three tab children and a
  // print page outside the sidenav. Open to every signed-in user like the
  // other menus (no operator allowlist, 2026-10-28).
  CallbotUsageFee: {
    name: 'CallbotUsageFee',
    path: '/callbot-usage-fees',
    Months: {
      name: 'CallbotUsageFeeMonths',
      path: '/callbot-usage-fees/months',
    },
    Profiles: {
      name: 'CallbotUsageFeeProfiles',
      path: '/callbot-usage-fees/profiles',
    },
    Ops: {
      name: 'CallbotUsageFeeOps',
      path: '/callbot-usage-fees/ops',
    },
    UsageStatement: {
      name: 'CallbotUsageFeeUsageStatement',
      path: '/callbot-usage-fees/usage-statement',
    },
  },

  // 연동관리
  Integration: {
    name: 'Integration',
    path: '/integration',
    ChannelManagement: {
      name: 'ChannelManagement',
      path: '/integration/channels',
    },
  },

  // 보안 설정
  Security: {
    name: 'Security',
    path: '/security',
    ChangePassword: {
      name: 'ChangePassword',
      path: '/security/change-password',
    },
    // 내 계정 보안(휴대폰·이메일 2차 인증 수단, W6 B1)
    MyAccount: {
      name: 'MyAccountSecurity',
      path: '/security/my-account',
    },
  },

  // 2단계 인증
  TwoFactorAuth: {
    name: 'TwoFactorAuth',
    path: '/two-factor-auth',
    Settings: {
      name: 'TwoFactorSettings',
      path: '/two-factor-auth/settings',
    },
    Verify: {
      name: 'TwoFactorVerify',
      path: '/two-factor-auth/verify',
    },
  },
};
